import apiClient from './client'

export interface AdminUserInfo {
  id: string
  email: string
  created_time: number | null
  empty_notes_count: number
  total_notes_count: number
  migrated_notes_count: number
  latest_note_time: number | null
  latest_note_backup: number | null
  latest_backup: number | null
  backed_up_success: boolean | null
}

export interface LogFile {
  name: string
  size_kb: number
  modified: string
}

export async function getAdminUsers(): Promise<AdminUserInfo[]> {
  const response = await apiClient.get<{ data: AdminUserInfo[] }>('/admin/users')
  return response.data.data
}

export async function migrateUser(userId: string): Promise<void> {
  await apiClient.post(`/admin/users/${userId}/migrate`)
}

export async function backupUser(userId: string): Promise<void> {
  await apiClient.post(`/admin/users/${userId}/backup`)
}

export async function getLogFiles(): Promise<LogFile[]> {
  const response = await apiClient.get<{ data: LogFile[] }>('/admin/logs')
  return response.data.data
}

export function getLogDownloadUrl(filename: string): string {
  return `/api/v1/admin/logs/${encodeURIComponent(filename)}`
}

